export default "__VITE_ASSET__CFSR$HWe__"